import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import Stack from "@mui/joy/Stack";
import Grid from "@mui/joy/Grid";
import Link from './Link';
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import CardActions from "@mui/joy/CardActions";
import Button from "@mui/joy/Button";
import { Identity } from 'stores/identity_store';
import { NewIdentityForm, VerifiedIdentityForm } from 'components/IdentityForm';
import { RootStoreContext } from 'stores/root_store';

import { UserIdentityContext } from 'contexts/user_identity_context';
import useUserIdentity from 'hooks/useUserIdentity';
import { Success, Error } from './FancyToast';

import IdentityAvatar from 'components/IdentityAvatar';

import useAuth from 'hooks/useAuth';

function ClientIdentitiesCard() {

    const uidStore = useContext(RootStoreContext).userIdentityStore;
    const navigate = useNavigate();

    const [stateVerifiedIdentity, setStateVerifiedIdentity] =
        useState({ 'verified': 'no',
            'role': 'client',
            'key': 'create-me',
        } as Identity);

    // useEffect(() => {
    //     if(selectedIdentity){
    //         setStateVerifiedIdentity(selectedIdentity);
    //     }
    // }, [selectedIdentity]);


    function onChangeRegularIdentity(e: Identity) {
        console.log("on change regular %o", e);
        setStateVerifiedIdentity({...stateVerifiedIdentity, ...e} as Identity);
    }

    function onSaveClick() {
        const identity = stateVerifiedIdentity;
        if (identity.key === 'create-me') {

            const newIdentity = {
                ...identity,
                'verified': 'no',
                'role': 'client',
            } as Identity;

            uidStore.createIdentity(newIdentity)
				.then(() => {
                    Success("Great! Saved.")
                    navigate(`/`);
				})
                .catch((error) => {
                    console.error(error);
                    Error("Error creating identity.")
                });
        } else {
            uidStore.updateIdentity(identity)
                .then(() =>{
                    Success("Updated!")
                    navigate(`/`);
                })
                .catch((err) => {
                    console.error(err);
                    Error("Error updating");
                });
        }
    }


    return (
        <Card>

            <CardContent>
                <Stack pb={3}>
                    <Typography>
                        You can create an additional <Typography variant="soft">identity</Typography> and collaborate using that name as well. Switch between your identities using the menu on the top right. {' '}
                        <Typography level="body-xs">
                            (Assistants cannot do this)
                        </Typography>
                    </Typography>
                </Stack>

                <NewIdentityForm
                    onChange={onChangeRegularIdentity} />
            </CardContent>

            <CardActions >
                <Stack ml="auto">


                    <Button  variant="solid" color="primary" onClick={onSaveClick}>
                        Save
                    </Button>
                </Stack>
            </CardActions>
        </Card>
    );
}

const IdentitiesSide = () => {
    const { identities } = useUserIdentity();
    const { currentUser } = useAuth();
    if(currentUser.allowed_identities <= 1) {
        return null;
    }

    return (
        <Stack m={3} spacing={1} >
            <Typography>
                Your account is allowed <Typography variant="soft">{currentUser.allowed_identities} identities</Typography>.
            </Typography>
            <Typography level="body-sm">
                These are you
            </Typography>
            { identities.map((i) =>
                <Link to={`/identity/${i.key}`}>
                    <IdentityAvatar  interactive={false} identityKey={i.key} size="inline" />
                </Link>
            ) }
        </Stack>
    );
}

const IdentityFrame = observer(() => {
    //    const [selectedIdentity, setIdentity] = useState({} as Identity);
    const { createIdentity, updateIdentity } = useUserIdentity();
    const { currentUser } = useAuth();
    const { verifiedIdentity, setVerifiedIdentity, identities } = useContext(UserIdentityContext);
    //    const [verifiedChanged, setVerifiedChanged] = useState(false);
    const navigate = useNavigate();

    const showClientIdentitiesCard =
        (currentUser.allowed_identities > identities.length) && verifiedIdentity?.key ;

    // const [stateVerifiedIdentity, setStateVerifiedIdentity] =
    //     useState({'verified': 'requested',
    //         'key': 'create-me',
    //     } as Identity);

    function onSaveClick(identity: Identity) {


        if (identity.key === 'create-me' || identity.key === undefined) {
            createIdentity(identity)
				.then((id) => {
                    if(id === undefined) {
                        Error("We had trouble saving this.")
                        return;
                    }
                    if(setVerifiedIdentity) {
                        setVerifiedIdentity(id);
                    }
                    navigate("/");
                    Success("Great! Saved.")
				})
                .catch((error) => {
                    console.error(error);
                    Error("We had trouble saving this.")
                });
        } else {
            // console.log("TRYING TO UPDATE: %o", identity);
            updateIdentity(identity)
                .then((id) =>{
                    if(id === undefined) {
                        Error("Had trouble updating.")
                        return;
                    }
                    console.log("setVerifiedIdentity is %o", setVerifiedIdentity);
                    if(setVerifiedIdentity) {
                        setVerifiedIdentity(id);
                        Success("Updated!")
                    }
                    else {
                        Error("I had trouble updating.")
                    }
                    // navigate('/');
                })
                .catch((err) => {
                    console.error(err);
                    Error("I had trouble saving this");
                });


        }
    }

    return (
        <Grid container>
            <Grid xs={12} sm={8} >

                { !verifiedIdentity?.key &&
                    <Stack m={3} spacing={1} >
                        <Typography level="title-md">
                            Welcome to Day Ones!
                        </Typography>
                    </Stack>
                }

                <Stack m={3} spacing={1} >
                    <Typography level="title-lg">
                        Let's set up your identity
                    </Typography>
                    <Typography level="body-md">
                        This is how the assistants will see you.
                    </Typography>

                    <VerifiedIdentityForm
                        onSaveClick={onSaveClick} />

                    { showClientIdentitiesCard &&
                        <ClientIdentitiesCard  /> }
                </Stack>
            </Grid>
            <Grid xs={12} sm={4} >
                { currentUser.allowed_identities > 1 &&
                    <IdentitiesSide /> }
            </Grid>
        </Grid>
    )
});

export default IdentityFrame;
